// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"UU-z","inlineTitle":"VU-z","sponsoredAdsWrapper":"WU-z","marketplaceRecosWrapper":"XU-z"};